import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuMain from './MenuMain';
import logo from 'components/assets/img/logo-flyo.svg';
import flag_no from 'components/assets/img/flag/no.svg';
import flag_uk from 'components/assets/img/flag/uk.svg';
import flag_pl from 'components/assets/img/flag/pl.svg';
import flag_ru from 'components/assets/img/flag/ru.svg';
import airplaneAvatar from 'components/assets/img/icons/airplane-avatar.svg';
import resizer from 'components/common/Resizer';
import { connect } from 'react-redux';
import { setUserLogout } from 'components/actions/authActions';
import { withStyles } from '@material-ui/core/styles';
import styles from '../customStylesRadioButton';
import Radio from '@material-ui/core/Radio';
import T from 'components/common/translations/Translate';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import { setTranslation } from 'components/actions'
import AppLink from 'components/common/AppLink';
import TransHelper from 'components/common/translations/TransHelper';
import withRouter from 'components/components/common/withRouter';
import originAxios from 'axios';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  handleChange = (lang, e) => {
    e.preventDefault();
    var value = lang;
    originAxios.post('/save-locale', { locale: value });

    if (value) {
      TransHelper.translateCurrentUrl(
        value,
        this.props.locale,
        this.props.history,
        this.props.location
      );
      this.props.setTranslation(value);
      LocalStorageHelper.setLocale(value);
    }
  };

  handleClickHamburger = e => {
    var overflowBody = document.body.classList;

    e.preventDefault();

    if (this.state.menuOpen == false) {
      this.setState({ menuOpen: true });
      overflowBody.add('menu-open');
    } else {
      this.setState({ menuOpen: false });
      overflowBody.remove('menu-open');
    }
  }

  closeMenu = (forwardCloseMenu) => {
    var overflowBody = document.body.classList;
    overflowBody.remove('menu-open');
    this.setState({ menuOpen: false });
  }

  render() {
    const isMobile = this.props.windowWidth <= 639;
    const { customer, isLogged, locale } = this.props;

    return (
      <Fragment>
        {!isLogged &&
          <Fragment>
            <header className="header">
              <div className="row">
                <AppLink
                  className="logo"
                  onClick={this.closeMenu}
                  title="Flyo"
                  to="routes.url.home"
                >
                  <img src={logo} alt="Flyo" />
                </AppLink>

                <div className="top-bar">
                  <AppLink
                    to='routes.url.login'
                    className="button button--outline"
                  >
                    <T>content.layout.header.logIn</T>
                  </AppLink>

                  {/* <Link to="/account" onClick={this.closeMenu}>
                    <span className="user">
                      <span className="user__icon">
                        <FontAwesomeIcon
                          icon={['fas', 'user']}
                          size="sm"
                        />
                      </span>
                      <span className="user__name">{customer.name}</span>
                    </span>
                  </Link> */}

                  <button title="Menu" className="hamburger" onClick={this.handleClickHamburger}>
                    <FontAwesomeIcon
                      icon={['fas', (this.state.menuOpen ? 'times' : 'bars')]}
                      size="lg"
                    />
                  </button>
                </div>
              </div>
            </header>

            <div id="menu-main" className={"menu-overlay" + (this.state.menuOpen ? " menu-overlay--active" : "")}>
              <div className="menu-wrapper">
                <div className="menu__desc">
                  <Fragment>
                    <div className="menu__intro">
                      <p><T>content.layout.header.welcomeMessage</T></p>
                      <AppLink to="routes.url.login" className="button button--outline">
                        <T>content.common.logIn</T>
                      </AppLink>
                    </div>

                    <div className="menu__register">
                      <p className="no-marg"><T>content.layout.header.registerMessage</T></p>
                      <p><T>content.layout.header.registerSecondMessage</T></p>
                      <AppLink to="routes.url.signup" className="button button--outline">
                        <T>content.layout.header.registerButton</T>
                      </AppLink>
                    </div>
                  </Fragment>

                  {/*
                  {this.props.isLogged &&
                    <div className="user-logged">
                      <p><T>content.layout.header.helloAgainTitle</T></p>

                      <AppLink to="routes.url.account" onClick={this.closeMenu}>
                        <figure className="user__image">
                          <img src={airplaneAvatar} alt="" />
                        </figure>
                      </AppLink>

                      <p className="user__full-name">
                        <AppLink to="routes.url.account" onClick={this.closeMenu}>{customer.name}</AppLink>
                      </p>

                      <p className="active">
                        <FontAwesomeIcon
                          icon={['fas', 'plane']}
                          size="sm"
                        />
                        <T variables={{ "count": "1" }}>content.layout.header.activeBookingCount</T>
                      </p>
                    </div>
                  } */}
                </div>

                <div className="menu__list">
                  <MenuMain forwardCloseMenu={this.closeMenu} locale={this.props.locale} />
                </div>
              </div>

              <div className="menu__lang">
                <ul>
                  <li className={classNames({
                    'active': locale === 'no'
                  })}>
                    <Link to="/no" onClick={(e) => this.handleChange('no', e)}>
                      <img src={flag_no} alt="Norwey" />
                    </Link>
                    {/* <Radio
                      value="no"
                      checked={locale === 'no'}
                      onChange={this.handleChange}
                      classes={{
                        root: this.props.classes.root,
                        checked: this.props.classes.checked,
                      }}
                      className="radio-button"
                      name="menu-language"
                      id="lang-no"
                    /> */}
                  </li>

                  <li className={classNames({
                    'active': locale === 'en'
                  })}>
                    <Link to="/" onClick={(e) => this.handleChange('en', e)}>
                      <img src={flag_uk} alt="English" />
                    </Link>
                    {/* <Radio
                      value="en"
                      checked={locale === 'en'}
                      onChange={this.handleChange}
                      classes={{
                        root: this.props.classes.root,
                        checked: this.props.classes.checked,
                      }}
                      className="radio-button"
                      name="menu-language"
                      id="lang-en"
                    /> */}
                  </li>

                  <li className={classNames({
                    'active': locale === 'pl'
                  })}>
                    <Link to="/pl" onClick={(e) => this.handleChange('pl', e)}>
                      <img src={flag_pl} alt="Polish" />
                    </Link>
                    {/* <Radio
                      value="pl"
                      checked={locale === 'pl'}
                      onChange={this.handleChange}
                      classes={{
                        root: this.props.classes.root,
                        checked: this.props.classes.checked,
                      }}
                      className="radio-button"
                      name="menu-language"
                      id="lang-pl"
                    /> */}
                  </li>

                  {/* <li className={classNames({
                    'active': locale === 'ru'
                  })}>
                    <Link to="/ru" onClick={(e) => this.handleChange('ru', e)}>
                      <img src={flag_ru} alt="русский" />
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </Fragment>
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    customer: state.auth.customer,
    locale: state.app.locale
  }
}

export default withRouter(
  resizer(
    connect(
      mapStateToProps, { setTranslation, setUserLogout }
    )(withStyles(styles)(Header))
  )
);
